<template>
  <v-data-table 
    v-if="cart.length > 0" 
    :items="cart" 
    :headers="headers" 
    item-key="itemkey" 
    class="px-0" 
    hide-actions 
    hide-headers>
    <template 
      slot="items" 
      slot-scope="props">
      <td class="pl-2 pr-0">
        <v-layout column>
          <span>
            {{ props.item.name }}
          </span>
          <span class="caption">
            {{ props.item.product_no }}
          </span>
        </v-layout>
      </td>
      <td 
        class="px-0" 
        style="max-width: 4em">
        <v-text-field 
          ref="qty" 
          v-model="cart[props.index].qty" 
          :error="cart[props.index].qty == null || cart[props.index].qty == ''" 
          :autofocus="$store.state.autofocus" 
          label="Määrä" 
          hide-details 
          type="number" 
          @focus="focus" 
          @blur="$store.state.qtyfocus = false" 
          @keyup.enter.native="blur" />
      </td>
      <td class="text-xs-right px-0">
        <v-btn 
          icon 
          @click="cart.splice(props.index, 1)">
          <v-icon>close</v-icon>
        </v-btn>
      </td>
    </template>
  </v-data-table>
</template>
<script>
export default {
	props: ['index'],
	data() {
		return {
			cart: [],
			headers: [
				{ text: 'Tuote', value: 'name', sortable: false },
				{ text: 'Määrä', value: 'qty', sortable: false },
				{ text: '', value: 'actions', sortable: false, align: 'right' }
			]
		}
	},
	computed: {
		carts() {
			return this.$store.state.carts
		}
	},
	watch: {
		carts() {
			this.cart = this.$store.state.carts[this.index].products
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.cart = this.$store.state.carts[this.index].products
		})
	},
	methods: {
		blur() {
			this.$refs.qty.blur()
		},
		focus(event) {
			event.target.select()
			this.$refs.qty.selection = 1
			if (navigator.maxTouchPoints > 0) {
				this.$store.state.qtyfocus = true
			}
		}
	}
}
</script>
<style>
.caption {
  color: #888;
}
</style>
